<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Close</v-toolbar-title>
          <v-spacer></v-spacer>
          <h3>Favoritos</h3>
        </v-toolbar>
        <template>
          <v-data-table
            :headers="headers"
            :items="persons"
            :items-per-page="5"
            class="elevation-1"
          >
          <template v-slot:[`item.Foto`]="{ item }">
         
            <v-img :src="item.picture.thumbnail" max-width="50" max-height="50" />
    
          </template>
          </v-data-table>

        </template>
        <v-btn color="secondary" elevation="2" @click="exportCVS"
          >Exportar Favoritos</v-btn
        >
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import FavoritStore from "../store/favoritosStore";
import exportFromJSON from 'export-from-json'

export default {
  data() {
    return {
      dialog: true,
      headers: [
        {
          text:"Foto",
          value: "Foto"
         },
        {
          text: "Gender",
          align: "start",
          sortable: false,
          value: "gender",
        },
        { text: "Name", value: "name.first" },
        { text: "Lastname", value: "name.last" },
        { text: "Email", value: "email" },
        { text: "Nat", value: "nat" },
        { text: "Date of bird", value: "dob.date" },
        { text: "Registered", value: "registered.date" },
      ],
      persons: FavoritStore.data.favorits,
    };
  },
  created() {
    console.log(this.persons);
  },
  methods: {
    closeModal() {
        this.dialog = false;
        this.$emit("closeVista3")
        this.dialog = true;
    },
     exportCVS() {
    const data = this.persons
    const fileName = 'download'
    const exportType =  exportFromJSON.types.csv

    exportFromJSON({ data, fileName, exportType })
    console.log(exportFromJSON)
  }

    
  },
};
</script>
